import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { stripeProducts } from '../stripe-config';
import { PricingCard } from '../components/subscription/PricingCard';
import { useAuth } from '../contexts/AuthContext';

export function Pricing() {
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      navigate('/account');
    }
  }, [user, navigate]);

  if (user) {
    return null;
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-green-50 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900 mb-6">
            Choose Your Plan
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Get your resume optimized with AI-powered technology. Start free, upgrade anytime.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-2 max-w-4xl mx-auto">
          {stripeProducts.map((product) => (
            <PricingCard
              key={product.id}
              product={product}
              isPopular={product.name.includes('Pro')}
            />
          ))}
        </div>

        <div className="mt-16 text-center">
          <p className="text-gray-600 mb-4">
            All plans include our core features. No hidden fees.
          </p>
          <p className="text-sm text-gray-500">
            Cancel anytime. Questions? Contact us at support@resumedoctorai.com
          </p>
        </div>
      </div>
    </div>
  );
}